export default "__VITE_ASSET__de22db12__"